export const CHECK_YOUR_EMAIL = "Please, check your email";